import type { TransactionPredicate } from './types';

export const hasTaxPaymentAmounts: TransactionPredicate = ({ taxPayments }) =>
    Boolean(
        taxPayments?.some(({ charges, credits }) => Boolean(credits?.length || charges?.length)),
    );
